import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Box, Dialog, DialogContent, DialogProps, IconButton, Slide, Tab, Tooltip } from '@material-ui/core';
import { TransitionProps } from '@material-ui/core/transitions';
import { Close } from '@material-ui/icons';
import { TabContext, TabList, TabPanel } from '@material-ui/lab';
import { RootState } from 'interfaces';
import { env } from 'config';
import { USER_OPERATIONS } from 'helper';
import { ACCESS_TOKEN_KEY } from 'providers/SessionProvider';

type Tabs = 'marketplace' | 'polls' | 'events';

const finalMarketplaceUrl = env.BIGAPP_MARKETPLACE_URL;
const finalPollsUrl = env.BIGAPP_POLLS_URL;

// События живут на том же хосте, что и опросы: раздел выбирается параметром redirect
const EVENTS_REDIRECT = 'community';

interface IProps extends DialogProps {}

const BigAppDialog = (props: IProps) => {
  const operations = useSelector((state: RootState) => state.operations);

  const availableTabs = [
    operations.includes(USER_OPERATIONS.MANAGE_BIG_APP_MARKETPLACE) && {
      value: 'marketplace' as Tabs,
      label: 'Заявка на платные услуги',
    },
    operations.includes(USER_OPERATIONS.MANAGE_BIG_APP_POLLS) && { value: 'polls' as Tabs, label: 'Опросы' },
    operations.includes(USER_OPERATIONS.VIEW_POLL_AND_EVENT) && { value: 'events' as Tabs, label: 'События' },
  ].filter(Boolean) as { value: Tabs; label: string }[];

  const [tabValue, setTabValue] = useState<Tabs>(() => availableTabs[0]?.value || 'marketplace');

  const token = localStorage.getItem(ACCESS_TOKEN_KEY);

  return (
    <Dialog {...props} TransitionComponent={SlideTransition} fullScreen>
      <DialogContent style={{ padding: 0, height: '100%' }}>
        <TabContext value={tabValue}>
          {/* Шапки у диалога нет — вкладки и закрытие в одной строке. Кнопка рендерится всегда:
              вкладки видит только носитель обоих прав, и внутри их условия закрывать было бы нечем */}
          <Box
            sx={{
              bgcolor: 'white',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              borderBottom: 1,
              borderColor: 'divider',
            }}
          >
            {availableTabs.length > 1 ? (
              <TabList onChange={(_, newValue) => setTabValue(newValue)}>
                {availableTabs.map(({ value, label }) => (
                  <Tab label={label} value={value} key={value} />
                ))}
              </TabList>
            ) : (
              <Box />
            )}

            <Tooltip title="Закрыть">
              <IconButton
                size="small"
                onClick={() => props.onClose?.({}, 'backdropClick')}
                aria-label="Закрыть"
                style={{ marginRight: 8 }}
              >
                <Close />
              </IconButton>
            </Tooltip>
          </Box>

          {operations.includes(USER_OPERATIONS.MANAGE_BIG_APP_MARKETPLACE) && (
            <TabPanel value="marketplace" style={{ display: 'flex', padding: 0 }}>
              <iframe
                src={`${finalMarketplaceUrl}?token=${token}`}
                title="Big App Marketplace"
                style={{ width: '100%', height: 'calc(100vh - 49px)', border: 'none' }}
              />
            </TabPanel>
          )}

          {operations.includes(USER_OPERATIONS.MANAGE_BIG_APP_POLLS) && (
            <TabPanel value="polls" style={{ display: 'flex', padding: 0 }}>
              <iframe
                src={`${finalPollsUrl}?token=${token}`}
                title="Big App Polls"
                style={{ width: '100%', height: 'calc(100vh - 49px)', border: 'none' }}
              />
            </TabPanel>
          )}

          {operations.includes(USER_OPERATIONS.VIEW_POLL_AND_EVENT) && (
            <TabPanel value="events" style={{ display: 'flex', padding: 0 }}>
              <iframe
                src={`${finalPollsUrl}?token=${token}&redirect=${EVENTS_REDIRECT}`}
                title="Big Life События"
                style={{ width: '100%', height: 'calc(100vh - 49px)', border: 'none' }}
              />
            </TabPanel>
          )}
        </TabContext>
      </DialogContent>
    </Dialog>
  );
};

const SlideTransition = React.forwardRef((props: TransitionProps, ref) => {
  return <Slide {...props} ref={ref} direction="up" />;
});

export default BigAppDialog;
